module.exports = __webpack_public_path__ + "img/de3a49vidas.9b138fd2.png";